import { SupportPartnershipSchema } from "@redotech/redo-support-partnerships-common/support-partnership";
import * as z from "zod";

export const getSupportPartnerships = {
  name: "getSupportPartnerships" as const,
  input: z.object({}),
  output: z.object({ partnerships: z.array(SupportPartnershipSchema) }),
};
